import React from "react";
import { useTheme } from "./ThemeProvider";

import sunIcon from "../../shared/assets/sun.svg";
import moonIcon from "../../shared/assets/moon.svg";

import "../styles/ThemeSwitcher.css";

function ThemeSwitcher() {
  const { theme, setTheme } = useTheme();

  // Activate light mode
  const handleLight = () => setTheme("theme-light");
  // Activate dark mode
  const handleDark = () => setTheme("theme-dark");

  return (
    <div className="theme-switcher-container">
      <button
        onClick={handleLight}
        className={`theme-option ${theme === "theme-light" ? "active" : ""}`}
      >
        <img src={sunIcon} alt="Sun" className="icon-sun" />
        <span>Light</span>
      </button>

      <button
        onClick={handleDark}
        className={`theme-option ${theme === "theme-dark" ? "active" : ""}`}
      >
        <img src={moonIcon} alt="Moon" className="icon-moon" />
        <span>Dark</span>
      </button>
    </div>
  );
}

export default ThemeSwitcher;
